import { formatDay, formatWhen } from './formatWhen'

// W60 (§3.11 #10): the Investment workspace's date helpers delegate to the
// one formatter both workspaces share. `dateConvert` is a calendar day (an
// effective date, a maturity); `dateOrTimeConvert` is a moment and now
// carries its zone like every Control-workspace timestamp (§16.2).
export const dateConvert = (date) => formatDay(date)

export const dateOrTimeConvert = (date) => formatWhen(date)

export const formatCreatedAt = (createdAt) => formatWhen(createdAt)
